import router from '@/router';
import { getUserInfo } from '@/api/login';

const user = {
  state: {
    userNIFCIF: '',
    name: '',
    authenticated: false,
    roles: [],
    token: null,
    empresas: [],
    browserInfo: '',
    versionApi: '',
    entorno: ''
  },
  mutations: {
    SET_NIFCIF: (state, userNIFCIF) => {
      state.userNIFCIF = userNIFCIF;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AUTHENTICATED: (state, authenticated) => {
      state.authenticated = authenticated;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_EMPRESAS: (state, empresas) => {
      state.empresas = empresas;
    },
    SET_BROWSER_INFO: (state, browserInfo) => {
      state.browserInfo = browserInfo;
    },
    SET_VERSION: (state, version) => {
      state.versionApi = version;
    },
    SET_ENTORNO: (state, entorno) => {
      state.entorno = entorno;
    },
    CLEAR_USER: state => {
      state.name = '';
      state.authenticated = false;
      state.roles = [];
      state.token = null;
      state.browserInfo = '';
      state.empresas = [];
      state.versionApi = '';
    }
  },
  actions: {
    login({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then(response => {
            commit('SET_NIFCIF', response.data.login);
            commit('SET_NAME', response.data.nombreCompleto);
            commit('SET_ROLES', response.data.roles);
            commit('SET_EMPRESAS', response.data.empresas);
            commit('SET_BROWSER_INFO', response.data.browserInfo);
            commit('SET_VERSION', response.data.version);
            commit('SET_ENTORNO', response.data.entorno);
            commit('SET_AUTHENTICATED', true);
            dispatch('sessionExpired', false);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    setLogged({ commit, dispatch }, userInfo) {
      commit('SET_NIFCIF', userInfo.login);
      commit('SET_NAME', userInfo.nombreCompleto);
      commit('SET_AUTHENTICATED', true);
      commit('SET_ROLES', userInfo.roles);
      commit('SET_EMPRESAS', userInfo.empresas);
      dispatch('sessionExpired', false);
    },
    logout({ commit }) {
      commit('CLEAR_USER');
      router.push({ name: 'login' });
    }
  }
};

export default user;
